import { Component, EventEmitter, Output } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { SettingsService } from 'src/app/services/settings.service';
import {CommercialsService} from 'src/app/services/commercials.service'
import { ToastMsg, ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';
import {HotelManagementService}  from 'src/app/services/hotel-management.service'

@Component({
  selector: 'app-hotel-commercials',
  templateUrl: './hotel-commercials.component.html',
  styleUrls: ['./hotel-commercials.component.css']
})
export class HotelCommercialsComponent {
  commercialData:any
  display:boolean=false
  action:any
  title:any
constructor(private toastMsgService:ToastmsgService,private CommercialsService:CommercialsService,private DataService:DataService,
  public SettingsService:SettingsService,private HotelManagementService:HotelManagementService){
  this.DataService.portMessage.subscribe((message:any) => this.commercialData = message)
  
    this.getHotelCommercial()

this.getSourcelist()
}

numbers: number[] = Array.from({ length: 50 }, (_, i) => i + 1);

columnsDataDisplay: string[] = ['data1','data2','data3','data4'];
  // columnsExistingDisplay: string[] = ['data1','data2','data3'];
  clearCommercial:boolean=false
  expandedElement!: any | null;
  totalElements:any=0
  hotelData:any=[]
  commercialMapping:any={
  planCode: "",
  isDefaultPlan: false,
  planPriority: '',
  commercialPlanItems:[]
}
  addCommercials(){
    let commercial=
        {
          "source": "",
          "supplier": "",
          "bookingType": "",
          "markupRates": [
            {
              "category": "Basic",
              "markupPercent": 0,
              "markupFixed": 0,
              "markupMax": 0
            },
            // {
            //   "category": "Fixed",
            //   "markupPercent": 0,
            //   "markupFixed": 0,
            //   "markupMax": 0
            // },
            // {
            //   "category": "Maximum",
            //   "markupPercent": 0,
            //   "markupFixed": 0,
            //   "markupMax": 0
            // }

          ],
          "commercialRates": [
            {
              "commercialCategory": "Commercial",
              "commercialRatePercent": 0,
              "commercialRateFixed": 0,
              "commercialOnBase": false,
              "commercialOnTax": false,
              "deductTds": false,
              "commercialApplicability": "Per Room"
            },
            {
              "commercialCategory": "Booking Fee",
              "commercialRatePercent": 0,
              "commercialRateFixed": 0,
              "commercialOnBase": false,
              "commercialOnTax": false,
              "deductTds": false,
              // "commercialApplicability": "Per Room"
            },
            {
              "commercialCategory": "Cancellation Fee",
              "commercialRatePercent": 0,
              "commercialRateFixed": 0,
              "commercialOnBase": false,
              "commercialOnTax": false,
              "deductTds": false,
              // "commercialApplicability": "Per Room"
            }
          ],
          "enablePassback":false,
          "passbackRetainRate": 0,
          "passbackAs": "T"
        
      }
    this.commercialMapping.commercialPlanItems.push(commercial)
    if(this.commercialMapping.commercialPlanItems.length>0){
      this.clearCommercial=true
      }else{
        this.clearCommercial=false
      
      }
  }

  clear(index:any){
  
    if(this.commercialMapping.commercialPlanItems.length>0){
      this.clearCommercial=true
      }else{
        this.clearCommercial=false
      
      }
    this.commercialMapping.commercialPlanItems.splice(index, 1);
  
  }
  updateCommercial() {
    // console.log('Updating commercial data...', this.commercials, this.passback, this.markups);
    // Implement API call to update data
  }

  deleteCommercial() {
    console.log('Deleting commercial data...');
    // Implement API call to delete data
  }
  @Output() myOutput:EventEmitter<string>= new EventEmitter();  

  onClickPopup(){
    this.DataService.portMessage.subscribe((message:any) => this.commercialData = message)

    this.title='Add Hotel Commercial'
    this.action='new'
    this.display=true
    this.commercialMapping={
      planCode: "",
      isDefaultPlan: false,
      planPriority: '',
      commercialPlanItems:[]
    }
  }
  onRowClick(element:any){
    this.title='Edit Hotel Commercial'
    this.action='update'
    this.display=true
    this.commercialMapping=element
    if(this.commercialMapping.commercialPlanItems.length>0){
      this.clearCommercial=true
      }else{
        this.clearCommercial=false
      
      }
  }
  checkKeyInObject(key: string, obj: any): boolean {
    return key in obj; // or use obj.hasOwnProperty(key);
  }
  updateHoteCommercial(){
    this.CommercialsService
    .updateHoteCommercial(this.commercialMapping,this.commercialMapping.id)
    .subscribe({
      next : (res:any) => {
        if(res) {
          // this.getCommercialbyPlanUid()
          this.display=false
          this.getHotelCommercial()

          this.toastMsgService.setMsg({msg : "Commercial Plan Updated Successfully!",msgTitle : "Success", msgType : "I"});
  
       
        } else {
  
        } 
      },error : (err) => {
  
        this.toastMsgService.setMsg({msg : "Failed to Update!",msgTitle : "Success", msgType : "W"});
  
      }
    }
  )
  }
  CreateCommercial(){
    this.CommercialsService
    .createHoteCommercial(this.commercialMapping,this.commercialData.id)
    .subscribe({
      next : (res:any) => {
        if(res) {
          // this.getCommercialbyPlanUid()
          // this.showPopup=false
          this.display=false
          this.getHotelCommercial()
          this.toastMsgService.setMsg({msg : "Commercial Plan Added Successfully!",msgTitle : "Success", msgType : "I"});
  
       
        } else {
  
        } 
      },error : (err) => {
  
        this.toastMsgService.setMsg({msg : "Failed to Save!",msgTitle : "Success", msgType : "W"});
  
      }
    }
  )
  }


  disable(){
    if(this.commercialMapping.planCode&&this.commercialMapping.planPriority){
     return false
    }else{
      return true

    }
  }

  getHotelCommercial(){
   
    this.CommercialsService
    .getHotelCommercial(this.commercialData.id)
    .subscribe({
      next : (res:any) => {
        if(res) {
       let data=res?.body
       console.log(data)
       this.hotelData=data
      //  console.log(this.airData)
  
        } else {
        
        } 
      },error : (err) => {
  
      }
    }
  )
  
  }
  sourceList:any=[]
getSourcelist(){

  this.HotelManagementService
  .getSourceList()
  .subscribe({
    next : (res:any) => {
      if(res) {
        const data = res
       

        this.sourceList=data;
    
      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}
supplierList:any=[]
getSupplierlist(code:any){

  this.HotelManagementService
  .getSupplierListBySource(code?.target?.value)
  .subscribe({
    next : (res:any) => {
      if(res) {
        const data = res
        this.supplierList=data;

      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}
}
